import { useQuery } from '@tanstack/react-query';
import { privacyApi } from '../api/privacy';

/**
 * Die geltenden Datenschutzhinweise.
 *
 * Lange vorgehalten, weil sie sich nur ändern, wenn jemand die Konfiguration
 * anfasst — aber nicht unbegrenzt: Wird die Anonymisierung umgestellt, während
 * jemand die Anwendung offen hat, bestätigte er sonst weiter die alte Fassung,
 * und der Server würde die Buchung mit PRIVACY_NOTICE_NOT_ACKNOWLEDGED
 * ablehnen, ohne dass die Oberfläche sagen könnte, warum.
 */
export function usePrivacyNotice() {
  return useQuery({
    queryKey: ['privacy-notice'],
    queryFn: () => privacyApi.notice(),
    staleTime: 10 * 60_000,
  });
}
